export const setScope = (scope) => ({
    type: "SET_SCOPE",
    payload: scope,
  });